<template>
	<div v-if="loadedConsoleStrings">
		<ws-cache-refresher />
		<component :is="layout">
			<router-view />
		</component>
		<ws-loading-spinner />

		<div id="modals" />
		<div id="root" />
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getCurrentInstance } from "vue";

const route = useRoute();
const loadedConsoleStrings = ref(false);
const instance = getCurrentInstance();
if (!instance) {
	throw new Error("Component instance not available");
}

const app = instance.appContext.app;
const client = app.config.globalProperties.$clientName;

const layout = computed(() => {
	const layoutName = (route.meta?.layout as string | undefined) || "app";
	return `${layoutName.toLowerCase()}-layout`;
});

const getCookieFromName = (cookieName: string) => {
	const cookies = decodeURIComponent(document.cookie)?.split(";");
	for (const cookie of cookies) {
		if (cookie?.toString()?.trim()?.indexOf(`${cookieName}=`) === 0) {
			return cookie.substring(`${cookieName}=`.length + 1);
		}
	}
	return "";
};

loadedConsoleStrings.value = true;

// eslint-disable-next-line
console.log(
	"Prod: " + import.meta.env.PROD,
	"Dev: " + import.meta.env.DEV,
	client
);

const authCookie = getCookieFromName("wsauthtoken");
if (
	authCookie &&
	authCookie !== "" &&
	!localStorage.getItem(import.meta.env.VITE_AUTH_TOKEN)
) {
	localStorage.setItem(import.meta.env.VITE_AUTH_TOKEN, authCookie);
}

onMounted(async () => {
	await app.config.globalProperties.$setClientTitleAndFavicon();
});
</script>
